import { doRequest } from '@r1-frontend/do-request';
import suggest from '@r1-frontend/api-domru/api-addresses/v1/suggest';
import { ResponseDto as DadataAddressSuggestionResponse } from '@r1-frontend/api-domru/dadata/suggest/dto/ResponseDto';
import check from '@r1-frontend/api-domru/dadata/v1/address/check';
import { ResponseDto } from '@r1-frontend/api-domru/dadata/v1/address/check/dto/ResponseDto';

import UnifiedAddressFormAnalytics from '@r1-frontend/unified-address-form/analytics';

import { checkingFinished, startChecking } from '../actions/index';
import { TSubmitButtonResult } from '../containers/SubmitButton';
import { TCtxDispatch } from '../Ctx';
import { TInitialState } from '../reducer/initialState';

const submit = (callback: (result: TSubmitButtonResult) => void, analytics: UnifiedAddressFormAnalytics) => async(dispatch: TCtxDispatch, getState: () => TInitialState) => {
    const { address, salePackageId, withReissue } = getState();

    analytics.checkClicked();
    dispatch(startChecking());

    const checkResponse = await doRequest.dadataProxy<ResponseDto>(check({ address, salePackageId, withReissue }));

    let checkingResult = {
        isConnectionAvailable: false,
        isTariffAvailableForActivation: undefined,
        message: 'Не&nbsp;смогли проверить ваш адрес. Пожалуйста, оставьте ваши ФИО и&nbsp;номер телефона &mdash; мы&nbsp;позвоним вам и&nbsp;всё проверим.',
    };
    let addressConnectionCost = undefined;
    let unifiedHouseId;
    let flat = '';

    if (checkResponse.isSuccess) {
        const connectionPrice = checkResponse.payload.connectionPrice;
        // @todo remove ignore, write dto
        // @ts-ignore
        checkingResult = {
            ...checkResponse.payload,
        };

        if (!checkResponse.payload.isConnectionAvailable || !checkResponse.payload.isInternetAvailable) {
            analytics.verificationFailed('Ваш дом пока не подключён к Дом.ру');
        }

        // if connection unavailable we will not need unified_house_id
        if (checkResponse.payload.isConnectionAvailable) {
            addressConnectionCost = connectionPrice?.value;

            analytics.verificationSuccess();
            const addressData = await doRequest.r1PlatformGateway<DadataAddressSuggestionResponse>(
                suggest(address),
            );

            if (addressData.isSuccess) {
                // @ts-ignore
                unifiedHouseId = Number(addressData.payload.suggestions[0].data.erth.unified_house_id);
                // @ts-ignore
                flat = addressData.payload.suggestions[0].data.flat;
            } else {
                analytics.verificationFailed('Не смогли проверить ваш адрес');
            }
        }
    } else {
        analytics.verificationFailed('Не смогли проверить ваш адрес');
    }

    dispatch(checkingFinished(checkingResult));

    callback({
        ...checkingResult,
        address: {
            value: address,
            flat,
            unifiedHouseId,
            connectionCost: addressConnectionCost,
        },
    });
};

export default submit;
